import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" {...props}>
    <path
      fill="none"
      stroke="#FFF"
      d="M15.89 1.404c.604.54.984.879 1.138 1.019.86.766 1 1.85.417 3.25-.874 2.102-4.151 7.17-11.288 11.453-1.575 1.108-2.99.858-3.64 0a88.726 88.726 0 0 0-1.273-1.643c-.462-.714-.268-1.376.583-1.987 1.277-.917.87-.594 1.912-1.309 1.043-.715 1.034-.555 2.418 0 1.383.556 1.396 1.04 2.767-.269.914-.872 2.084-2.064 3.512-3.575.536-.504.536-1.132 0-1.884-.803-1.129-.803-1.563 0-2.8a23.43 23.43 0 0 1 1.654-2.255c.595-.539 1.195-.539 1.8 0z"
    />
  </svg>
);
const Memo = memo(SvgCall);
export default Memo;
